module.exports = __webpack_public_path__ + "img/why3.9f11c751.svg";